import { render, staticRenderFns } from "./ArCollections.vue?vue&type=template&id=9db1bbf0&scoped=true&"
import script from "./ArCollections.vue?vue&type=script&lang=js&"
export * from "./ArCollections.vue?vue&type=script&lang=js&"
import style0 from "./ArCollections.vue?vue&type=style&index=0&id=9db1bbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db1bbf0",
  null
  
)

export default component.exports